import axios from "axios";
import React, { useState, useEffect } from "react";
import { Modal, Button, Table } from "semantic-ui-react";
import "../../node_modules/react-vis/dist/style.css";
import "../css/home.css";
import { API_KEYS, FMP_API_ENDPOINTS } from "../util/Constants";
import Constants from "../util/Constants";
import GainersLosers from "./GainersLosers";
import SectorGainersLosers from "./SectorGainersLosers";
import Markets from "./Markets";
import SectorMap from "./SectorMap";
import IndexMap from "./IndexMap";
import CompanyPage from "../company/CompanyPage";
import LoadingSpinner from "../util/LoadingSpinner";
import { useMobile } from "../MobileContext";
import { Tabs, Tab, Box } from "@mui/material";

const HomeContainer = (props) => {
  const isMobile = useMobile().isMobile;

  const [stateValues, setstateValues] = useState({
    open: false,
    indexList: [],
    gainersLosers: [],
    modalSymbol: "",
    loading: true,
  });

  const showModal = (symbol) => {
    setstateValues({ ...stateValues, modalSymbol: symbol, open: true });
  };

  const setOpen = (flag) => {
    setstateValues({ ...stateValues, open: flag });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          indexResponse,
          gainersLosersResponse,
          goldQuote,
          silverQuote,
          oilQuote,
          bitcoinQuote,
        ] = await Promise.all([
          axios.get(`${FMP_API_ENDPOINTS.INDEX()}?${API_KEYS.FMP_API_KEY}`),
          axios.get(Constants.LEADERS_URL),
          axios.get(`${FMP_API_ENDPOINTS.GOLD()}?${API_KEYS.FMP_API_KEY}`),
          axios.get(`${FMP_API_ENDPOINTS.SILVER()}?${API_KEYS.FMP_API_KEY}`),
          axios.get(`${FMP_API_ENDPOINTS.OIL()}?${API_KEYS.FMP_API_KEY}`),
          axios.get(`${FMP_API_ENDPOINTS.CRYPTO()}?${API_KEYS.FMP_API_KEY}`),
        ]);

        const rawGainersLosers = gainersLosersResponse.data?.gainersLosers;
        const gainersLosers =
          rawGainersLosers &&
          typeof rawGainersLosers === "object" &&
          !Array.isArray(rawGainersLosers)
            ? rawGainersLosers
            : {};

        setstateValues({
          indexList: (indexResponse.data || []).filter(
            (dataItem) =>
              dataItem.name === "Dow Jones Industrial Average" ||
              dataItem.name === "NASDAQ Composite" ||
              dataItem.name === "S&P 500" ||
              dataItem.name === "Russell 2000" ||
              dataItem.name === "CBOE Volatility Index"
          ),
          gainersLosers,
          gold: goldQuote.data,
          silver: silverQuote.data,
          oil: oilQuote.data,
          bitcoin: bitcoinQuote.data,
          loading: false,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
        setstateValues((prev) => ({
          ...prev,
          gainersLosers: {},
          loading: false,
        }));
      }
    };

    fetchData();
  }, []);

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const renderTabContent = () => {
    switch (value) {
      case 0:
        return stateValues.loading ? (
          <LoadingSpinner mleft="0%" />
        ) : (
          <GainersLosers
            gainersLosers={stateValues.gainersLosers}
            onClickSymbolFunction={showModal}
          />
        );
      case 1:
        return (
          <SectorGainersLosers
            gainersLosers={stateValues.gainersLosers}
            onClickSymbolFunction={showModal}
          />
        );
      case 2:
        return (
          <SectorMap
            gainersLosers={stateValues.gainersLosers}
            sectorMap={stateValues.gainersLosers.quotesBySector}
            title="Performance of top 10 companies by market value in each sector"
            onClickSymbolFunction={showModal}
          />
        );
      case 3:
        return (
          <SectorMap
            sectorMap={stateValues.gainersLosers.dowQuotesBySector}
            title="Performance of Dow 30 companies in each sector"
            onClickSymbolFunction={showModal}
            cellsPerRow={15}
          />
        );
      case 4:
        return (
          <SectorMap
            sectorMap={stateValues.gainersLosers.nasdaqQuotesBySector}
            title="Performance of NASDAQ 100 companies in each sector"
            onClickSymbolFunction={showModal}
          />
        );
      case 5:
        return (
          <SectorMap
            sectorMap={stateValues.gainersLosers.spQuotesBySector}
            title="Performance of S &amp; P 500 companies in each sector"
            onClickSymbolFunction={showModal}
          />
        );
      case 6:
        return (
          <IndexMap
            indexMap={stateValues.gainersLosers.dowList}
            title="Performance of Dow 30 companies"
            onClickSymbolFunction={showModal}
          />
        );
      case 7:
        return (
          <IndexMap
            indexMap={stateValues.gainersLosers.nasdaqList}
            title="Performance of NASDAQ 100 companies"
            onClickSymbolFunction={showModal}
          />
        );
      case 8:
        return (
          <IndexMap
            indexMap={stateValues.gainersLosers.spList}
            title="Performance of S &amp; P 500 companies"
            onClickSymbolFunction={showModal}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div
        id="container"
        className="home-container"
        style={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginBottom: "56px",
          overflowX: "hidden",
        }}
      >
        <div
          id="markets"
          className="markets-card-wrapper"
          style={{
            width: "100%",
            maxWidth: isMobile ? "95%" : "900px",
            margin: "10px auto",
            padding: isMobile ? "12px" : "20px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            borderRadius: isMobile ? "12px" : "20px",
          }}
        >
          <Markets
            indexList={stateValues.indexList}
            gold={stateValues.gold}
            silver={stateValues.silver}
            oil={stateValues.oil}
            bitcoin={stateValues.bitcoin}
            onClickIndexFunction={props.onClickIndexFunction}
          />
        </div>

        <div id="tabs" className="home-tabs-wrapper" style={{ width: "100%", maxWidth: isMobile ? "100%" : "1250px", minWidth: 0 }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider", width: "100%", overflow: "hidden" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              <Tab label="Index Gainers and Losers" />
              <Tab label="Sector Gainers and Losers" />
              <Tab label="Top 10 by Sector" />
              <Tab label="Dow by Sector" />
              <Tab label="NASDAQ by Sector" />
              <Tab label="S & P by Sector" />
              <Tab label="Dow Map" />
              <Tab label="NASDAQ Map" />
              <Tab label="S & P Map" />
            </Tabs>
          </Box>
          <Box sx={{ padding: isMobile ? 1.5 : 2, width: "100%", minWidth: 0, overflow: "hidden" }}>{renderTabContent()}</Box>
        </div>
      </div>
      <Modal
        closeOnEscape={true}
        onClose={() => setOpen(false)}
        centered={true}
        open={stateValues.open}
        size="fullscreen"
        style={{ marginLeft: "2%" }}
      >
        <Modal.Content scrolling>
          <Modal.Description>
            <CompanyPage symbol={stateValues.modalSymbol} />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button className="ui blue button" onClick={() => setOpen(false)}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};
export default HomeContainer;
